import React from 'react';

import { SubRoutes } from '../../routes';

import RecordListPage from './_list';
import RecordEditPage from './_edit';
import RecordStatusPage from './_status';
import RecordCommentPage from './_comment';

const MainRecordPage = () => {
  return <SubRoutes name="record" />;
};

const Record = {
  MainRecordPage,
  RecordListPage,
  RecordEditPage,
  RecordStatusPage,
  RecordCommentPage,
};

export default Record;
